import type { RouteLocationAsRelative } from 'vue-router'

import { BroadcastID } from './models/broadcast'

export interface BroadcastRef {
  id: BroadcastID
  orgSlug: string
}

export const broadcastRoutes = {
  list: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/people/broadcasts/'> => ({
    name: '/(app)/[org]/people/broadcasts/',
    params: { org },
  }),

  create: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/people/broadcasts.create'> => ({
    name: '/(app)/[org]/people/broadcasts.create',
    params: { org },
  }),

  detail: (
    b: BroadcastRef,
  ): RouteLocationAsRelative<'/(app)/[org]/people/broadcasts/[id]/'> => ({
    name: '/(app)/[org]/people/broadcasts/[id]/',
    params: { org: b.orgSlug, id: b.id },
  }),
}
